module.exports = ".no-underline {\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.toggle-container {\n  background-color:white;\n  -webkit-box-sizing:border-box;\n          box-sizing:border-box;\n  overflow:hidden;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/filterable-grid/filter-column/filter-column.component.css
// module id = ./src/app/shared/components/filterable-grid/filter-column/filter-column.component.css
// module chunks = main